const itemUpgrade = `

#### How to Obtain Ancient Steel
- **Collect Ancient Steel Fragments** from various sources.
- **100 Fragments** can be converted into **1 Ancient Steel**.
- **To convert**, double-click the fragments in your inventory.
- Visit the **Ancient Blacksmith** in the **Ruined City** to upgrade your weapon.

#### Upgrade Costs & Requirements
| Upgrade Level | Rupees Cost | Ancient Steel Required |
|--------------|-------------|------------------------|
| **Lv. 11**  | 1,000,000   | 1                      |
| **Lv. 12**  | 2,000,000   | 2                      |
| **Lv. 13**  | 3,000,000   | 3                      |
| **Lv. 14**  | 4,000,000   | 4                      |
| **Lv. 15**  | 5,000,000   | 5                      |
| **Lv. 16**  | 6,000,000   | 6                      |
| **Lv. 17**  | 7,000,000   | 7                      |
| **Lv. 18**  | 8,000,000   | 8                      |
| **Lv. 19**  | 9,000,000   | 9                      |
| **Lv. 20**  | 10,000,000  | 10                     |

### Upgrade Process
1. **Gather enough Ancient Steel** based on the level you want to achieve.
2. **Ensure you have the required Rupees**.
3. **Go to the Ancient Blacksmith** in the Ruined City.
4. **Use the upgrade window** to enhance your weapon.
5. **Enjoy your upgraded gear!** ⚔️

Start upgrading your weapons now and dominate the battlefield! 🎯`;

export default itemUpgrade;
